import { Plus } from 'lucide-react';

/**
 * Floating Action Button — used at the bottom-right of full-screen mobile pages.
 *
 * Brand-colored (primary red) circular pill that floats above the bottom tab
 * bar with a subtle shadow. Accepts either `to` (Link), or `onClick`.
 */
export function FloatingActionButton({ to, onClick, icon: Icon = Plus, label = 'Add', testid = 'fab' }) {
  const className = 'fixed bottom-20 right-5 z-30 h-14 w-14 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 flex items-center justify-center hover:scale-105 active:scale-95 transition-transform';
  const inner = (
    <>
      <Icon className="h-6 w-6" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </>
  );
  if (to) {
    // Use anchor so this works without needing react-router-dom import here.
    return (
      <a href={to} className={className} data-testid={testid} aria-label={label}>
        {inner}
      </a>
    );
  }
  return (
    <button onClick={onClick} className={className} data-testid={testid} aria-label={label} type="button">
      {inner}
    </button>
  );
}
